/** When your routing table is too long, you can split it into small modules**/

import Layout from "@/views/layout/layout";

const orderManageRouter = {
  path: "/orderManage",
  component: Layout,
  hidden: false,
  redirect: "noredirect",
  name: "OrderManage",
  meta: {
    title: "订单管理",
    icon: "order",
    roles: ["admin"]
  },
  children: [
    {
      path: "payOrder-27",
      component: resolve =>
        require(["@/views/manage/orderManage/payOrder"], resolve),
      name: "PayOrder",
      meta: { title: "API代收订单", noCache: false }
    },
    {
      path: "withdrawList-33",
      component: resolve =>
        require(["@/views/manage/orderManage/withdrawList"], resolve),
      name: "WithdrawList",
      meta: { title: "API代付订单", noCache: false }
    },
    {
      path: "merchantPayOrder",
      component: resolve =>
        require([
          "@/views/manage/merchantAccountManage/merchantPayOrder"
        ], resolve),
      name: "MerchantPayOrder",
      meta: { title: "网银B2C充值订单", noCache: false, noKeepAlive: true }
    },
    {
      path: "merchantPayOrderU",
      component: resolve =>
        require([
          "@/views/manage/merchantAccountManage/merchantPayOrder"
        ], resolve),
      name: "MerchantPayOrderU",
      meta: { title: "后台充U订单", noCache: false, noKeepAlive: true }
    },
    {
      path: "apiRechargeOrder",
      component: resolve =>
        require(["@/views/manage/orderManage/apiRechargeOrder"], resolve),
      name: "ApiRechargeOrder",
      meta: { title: "USDT代收订单", noCache: false }
    },
    // {
    //   path: "apiCfbRechargeOrder",
    //   component: resolve =>
    //     require(["@/views/manage/orderManage/apiCfbRechargeOrder"], resolve),
    //   name: "ApiCfbRechargeOrder",
    //   meta: { title: "CFB代收订单", noCache: false }
    // },
    {
      path: "fillOrder",
      component: resolve =>
        require(["@/views/manage/orderManage/fillOrder"], resolve),
      name: "FillOrder",
      meta: { title: "USDT补单订单", noCache: false }
    },
    {
      path: "payOrder:errorOrder",
      component: resolve =>
        require(["@/views/manage/orderManage/payOrderError"], resolve),
      name: "PayOrderError",
      meta: { title: "代收异常订单", noCache: false }
    },
    {
      path: "remit:errorOrder",
      component: resolve =>
        require(["@/views/manage/orderManage/withdrawListError"], resolve),
      name: "WithdrawListError",
      meta: { title: "代付异常订单", noCache: false }
    },
    {
      path: "freezeOrder-312",
      component: resolve =>
        require(["@/views/manage/orderManage/freezeOrder"], resolve),
      name: "FreezeOrder",
      meta: { title: "冻结订单", noCache: false }
    },
    {
      path: "withdrawListReject",
      component: resolve =>
        require(["@/views/manage/orderManage/withdrawListReject"], resolve),
      name: "WithdrawListReject",
      meta: { title: "代收付拦截订单", noCache: false }
    },
    {
      path: "withdrawPendingRefund-276",
      component: resolve =>
        require(["@/views/manage/orderManage/withdrawPendingRefund"], resolve),
      name: "WithdrawPendingRefund",
      meta: { title: "失败待退款代付订单", noCache: false }
    },
    {
      path: "withdrawPendingAudit-277",
      component: resolve =>
        require(["@/views/manage/orderManage/withdrawPendingAudit"], resolve),
      name: "WithdrawPendingAudit",
      meta: { title: "退款待审核代付订单", noCache: false }
    },
    // {
    //   path: 'fundChangeRecord',
    //   component: resolve => require(['@/views/manage/merchantManage/fundChangeRecord'], resolve),
    //   name: 'FundChangeRecord',
    //   meta: { title: '资金流水记录', noCache: false }
    // },
    {
      path: "transferRecord",
      component: resolve =>
        require(["@/views/manage/merchantManage/transferRecord"], resolve),
      name: "TransferRecord",
      meta: { title: "商户互转记录", noCache: false }
    },
    {
      path: "paidBanksRecord",
      component: resolve =>
        require(["@/views/manage/orderManage/paidBanksRecord"], resolve),
      name: "PaidBanksRecord",
      meta: { title: "提现银行卡记录", noCache: false }
    },
    {
      path: "patchNotes",
      component: resolve =>
        require(["@/views/manage/orderManage/patchNotes"], resolve),
      name: "PatchNotes",
      meta: { title: "补单记录", noCache: false }
    },
    {
      path: "appealOrder",
      component: resolve =>
        require(["@/views/manage/orderManage/appealOrder"], resolve),
      name: "AppealOrder",
      meta: { title: "申诉订单", noCache: false }
    },
    // {
    //   path: 'malePaymentDispose',
    //   component: resolve => require(['@/views/manage/orderManage/malePaymentDispose'], resolve),
    //   name: 'MalePaymentDispose',
    //   meta: { title: '对公代付处理', noCache: false }
    // }
    {
      path: "quickOrderInfo",
      component: resolve => require(["@/views/manage/orderManage/quickOrderInfo"], resolve),
      name: "QuickOrderInfo",
      meta: { title: "快捷订单信息", noCache: false }
    },
    {
      path: "payInterceptMemberNoRecord",
      component: resolve => require(["@/views/manage/orderManage/payInterceptMemberNoRecord"], resolve),
      name: "PayInterceptMemberNoRecord",
      meta: { title: "代收需拦截会员", noCache: false }
    },
  ]
};

export default orderManageRouter;



// WEBPACK FOOTER //
// ./src/router/manage/orderManage.js